import React, { Component } from "react";
import { Outlet, Navigate } from "react-router-dom";
import PersonalCenterLeftRender from "./children/PersonalCenterLeftRender";
import PurchaseModal from "./children/purchaseModal/PurchaseModal";
import Cookies from "js-cookie";

import "../../assets/personalCenter.scss";

export default class PersonalCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      purchaseModalVisible: false, //购买弹窗显示控制变量
    };
  }

  componentDidMount() {
    //当用户没有登录认证的时候，跳出当前页面
    if (!Cookies.get("authorization")) {
      this.handleNavigationToLogin();
    }
  }
  /**
   * 跳转到登录
   */
  handleNavigationToLogin = () => {
    this.setState(
      {
        linkToLogin: true,
      },
      () =>
        this.setState({
          linkToLogin: false,
        })
    );
  };

  /**
   *控制购买弹窗出现和关闭
   * @param {Boolean} purchaseModalVisible
   */
  handlePurchaseModalVisible = purchaseModalVisible => {
    this.setState({
      purchaseModalVisible,
    });
  };

  render() {
    return (
      <>
        {this.state.linkToLogin && <Navigate to="/login" replace={true} />}
        <div className="presonal-center-page container px-0 px-md-3 d-flex flex-md-row flex-column mt-0 mt-md-5 mb-5 pb-5 position-relative">
          <div className="lft position-md-sticky position-static me-0 pe-0 me-md-5 pe-md-4">
            <PersonalCenterLeftRender handlePurchaseModalVisible={this.handlePurchaseModalVisible} />
          </div>
          <div className="rgt px-3 px-md-0">
            <Outlet />
          </div>
          {this.state.purchaseModalVisible && (
            <PurchaseModal visible={this.state.purchaseModalVisible} handleVisible={this.handlePurchaseModalVisible} />
          )}
        </div>
      </>
    );
  }
}
